const useAssignRef = <T = any>(ref: React.Ref<T>, value: T | null) =>
  typeof ref === 'function'
    ? ref(value)
    : typeof ref === 'object' && ref != null
      ? (ref.current = value)
      : null;

export default useAssignRef;
